import React, { useContext, useEffect, useState } from "react";
import NoSearchitems from "../../../components/NoSearchitems";
import { MdEdit } from "react-icons/md";
import ActionBlueButtonOrders from "../../KYC/ActionBlueButtonOrders";
import UnitsSelectModal from "../UnitsSelectModal";
import PartActionModal from "../Part/PartActionModal";
import { PartialType } from "./PartialRevokeTable";
import partialIcon from "../../../images/partialIcon.svg";
function PartOrderLoanTable({
  tableArray,

  orderId,
  setReRender,
  reRender,
  isOd,
  setIndexRerender,
  setPartUserView,
}) {
  const [totalSelectedAmount, setTotalSelectedAmount] = useState(0);
  const [totalSelectedUnit, setTotalSelectedUnit] = useState(0);
  const [orderArray, setOrderArray] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const type = useContext(PartialType);
  const [initialArrayFetch, setInitialArrayFetch] = useState(false);
  const [fundDetails, setFundDetails] = useState({
    name: "",
    unitPrice: 0,
    unitsAvailable: 0,
  });

  function truncateText(text, maxLength = 40) {
    if (text?.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    } else {
      return text;
    }
  }
  function replaceUnderscores(text) {
    if (text === null || text === undefined) return "--";
    return text.replace(/_/g, " ");
  }

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  const handleLoanSelect = (unit, price, index, pledge_no, repository) => {
    const updatedOrderArray = orderArray?.map((item, i) => {
      if (i !== index) return item;

      const selected = !item?.selected;
      return {
        ...item,
        selected,
        unit: selected ? unit : 0,
        value: selected ? price * unit : 0,
        pledge_no: selected ? pledge_no : "",
        repository: selected ? repository : "",
      };
    });

    setOrderArray(updatedOrderArray);
  };

  const calculateTotal = () => {
    const totalValue = orderArray?.reduce((acc, item) => {
      if (item?.selected) {
        return acc + item.value;
      }
      return acc;
    }, 0);

    const totalUnit = orderArray?.reduce((acc, item) => {
      if (item?.selected) {
        return acc + item.unit;
      }
      return acc;
    }, 0);

    setTotalSelectedAmount(totalValue);
    setTotalSelectedUnit(totalUnit);
  };
  const handleUnitChange = (units, index, unitPrice) => {
    const updatedOrderArray = orderArray?.map((item, i) => {
      if (i !== index) return item;

      return {
        ...item,
        selected: units > 0 && !isNaN(units) ? true : false,
        unit: !isNaN(units) ? units : 0,
        value: !isNaN(units) ? units * unitPrice : 0,
      };
    });

    setOrderArray(updatedOrderArray);
  };
  useEffect(() => {
    calculateTotal();
  }, [orderArray]);

  useEffect(() => {
    if (tableArray?.length === 0 && !initialArrayFetch) {
      return;
    } else {
      setOrderArray(
        tableArray?.map((data) => ({
          unit: 0,
          value: 0,
          selected: false,
          pledge_no: "",
          repository: "",
          uuid: data?.uuid ? data.uuid : "",
        }))
      );
      setInitialArrayFetch(true);
    }
  }, [tableArray]);
  return (
    <>
      <div className=" rounded border border=[#e2ecff] mt-4  overflow-auto">
        <table className="w-full min-w-[1160px] box-border  flex flex-col mt-4 rounded ">
          <thead className="text-xs font-semibold">
            <tr className="w-full flex items-center">
              <td className="text-center pl-3 pr-2  pt-3 pb-2 w-[7%]"></td>
              <th className="text-left   pt-1 pb-3 w-[12%] ">
                Pledge Reference No.
              </th>
              <th className=" w-[4%]"></th>
              <th className={`text-left pl-4  w-[25%] pr-5`}>Constituents</th>

              <th className="text-left  w-[14%]">Repository</th>
              <th className={`text-left w-[13%] `}>LTV(%)</th>
              <th className={`text-left w-[15%]   `}>
                Initial Pledged Unit Price
              </th>

              <th className={`text-left w-[19%] pl-6`}>Pledged Units</th>
              <th className={`text-left w-[15%] pl-1`}>Remaining Units</th>
              <th className={`text-right w-[20%] pr-6`}>
                Selected Units Value (Selected No. of Units)
              </th>
            </tr>
          </thead>

          <tbody className={`    ${tableArray?.length === 0 ? " h-fit " : ""}`}>
            {tableArray?.length === 0 && (
              <>
                <NoSearchitems />
              </>
            )}
            {tableArray?.map((data, index) => (
              <tr
                key={index + data.pledged_reference_number}
                className={`text-xs font-medium w-full flex items-center  h-[60px] ${
                  index % 2 === 0 ? "bg-[#f8f8f8]" : "bg-white"
                } ${orderArray[index]?.selected ? "!bg-[#effbff]" : ""}`}
              >
                <td className="text-center pl-3 pr-2  pt-3 pb-2 w-[7%]">
                  <input
                    type="checkbox"
                    checked={orderArray[index]?.selected}
                    onChange={() => {
                      if (data.remaining_units <= 0) return;
                      if (data.repository !== "Cams" && !isOd) return;
                      handleLoanSelect(
                        data.remaining_units,
                        data.initial_pledge_unit_price,
                        index,
                        data.pledged_reference_number,
                        data.repository
                      );
                    }}
                  />
                </td>
                <td className="text-left    w-[12%]">
                  {data?.pledged_reference_number || "--"}
                </td>
                <td className=" w-[4%] flex justify-end">
                  {data.initial_pledged_unit > data.remaining_units && (
                    <img src={partialIcon} alt="partial" width={12} />
                  )}
                </td>
                <td
                  className={`text-left w-[25%] pt-3 pb-2 pl-4 pr-5`}
                  title={data?.consituents}
                >
                  {truncateText(data?.consituents, 57)}
                </td>
                <td className="text-left  w-[14%]">
                  {" "}
                  {`${data.repository}/${replaceUnderscores(
                    data.pledged_status
                  )}`}
                </td>
                <td className={`text-left w-[13%] `}>{data?.ltv}</td>
                <td className={`text-left w-[15%] `}>
                  {formatToIndianRupees(data?.initial_pledge_unit_price)}
                </td>

                <td className={`text-left w-[20%] pl-6`}>
                  {data?.initial_pledged_unit || "--"}
                </td>
                <td className={`text-left w-[15%] pl-1`}>
                  {data?.remaining_units !== null ? data.remaining_units : "--"}
                </td>
                <td className={`text-right w-[19%] pr-6 flex justify-end`}>
                  <div className="flex flex-col">
                    {formatToIndianRupees(orderArray[index]?.value)}{" "}
                    <span>(Units: {orderArray[index]?.unit})</span>
                  </div>
                  <button
                    disabled={!orderArray[index]?.selected}
                    onClick={() => {
                      setFundDetails({
                        name: data.consituents,
                        unitPrice: parseFloat(data.initial_pledge_unit_price),
                        unitsAvailable: orderArray[index].unit,
                        index: index,
                        maximumUnits: data.remaining_units,
                      });
                      setEditModal(true);
                    }}
                    className={` ml-3 h-8 w-8 flex items-center border border-[#dadada] bg-white rounded justify-center`}
                  >
                    <MdEdit color="#656565" size={17} />
                  </button>
                </td>
              </tr>
            ))}
            <tr className=" flex justify-end pr-6 h-[90px] bg-[#e6ebed]">
              <div className=" py-[12px] text-xs font-bold .">
                <p className=" text-right mb-[1px] pr-[1px]">
                  Selected Amount
                  <span className=" ml-[18px]">
                    {formatToIndianRupees(totalSelectedAmount)}
                  </span>
                </p>
                {/* <p className="pr-[1px]">
                  (Selected No. of Units)
                  <span className=" ml-[18px]">({totalSelectedUnit})</span>
                </p> */}
                <div className=" flex justify-end mt-4">
                  {" "}
                  <ActionBlueButtonOrders
                    partial={true}
                    disabled={totalSelectedAmount === 0 ? true : false}
                    text={type === "revoke" ? " Part Revoke" : " Part Invoke"}
                    onClick={() => {
                      if (totalSelectedAmount === 0) return;
                      setConfirmationModal(true);
                    }}
                  />
                </div>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
      {editModal && (
        <UnitsSelectModal
          modalOpen={setEditModal}
          fundDetails={fundDetails}
          handleUnitChange={handleUnitChange}
        />
      )}
      {confirmationModal && (
        <PartActionModal
          cancelFunction={setConfirmationModal}
          selectedArray={orderArray}
          orderId={orderId}
          setReRender={setReRender}
          reRender={reRender}
          isOd={isOd}
          setIndexRerender={setIndexRerender}
          setPartUserView={setPartUserView}
        />
      )}
    </>
  );
}

export default PartOrderLoanTable;

//overflow-auto  max-h-[calc(100vh-325px)]
